<template>
  <div id="loginOrRegister">
    <!-- 切换卡片 -->
    <div class="check">
      <!-- 切换选择 -->
      <div class="check_wrapper container" v-if="active != 'forgetPwd'">
        <!-- 登录注册切换 -->
        <div
          class="login"
          :class="{ active: active == 'login' }"
          @click="changeCard('login')"
        >
          登入
        </div>
        <div
          class="register"
          :class="{ active: active == 'register' }"
          @click="changeCard('register')"
        >
          註冊
        </div>
      </div>
      <!-- 忘记密码 -->
      <div class="check_wrapper container" v-else>
        <div class="login active">忘記密碼</div>
      </div>
    </div>

    <!-- 登录和注册 -->
    <div class="card">
      <div class="card_wrapper container">
        <!-- 登录 -->
        <div class="login" v-if="active == 'login'">
          <div class="tips">
            透過 手機 / LINE 註冊， 即可直接解鎖推薦碼，享受優惠！
          </div>
          <div class="login_wrapper">
            <div class="form">
              <div class="inputGroup">
                <input
                  type="text"
                  required=""
                  autocomplete="off"
                  v-model="loginForm.account"
                />
                <label for="name">請輸入手機 / 電子信箱 / 使用者名稱</label>
                <!-- 表单验证提示 -->
                <span class="varify"></span>
              </div>
              <div class="inputGroup">
                <input
                  type="text"
                  required=""
                  autocomplete="off"
                  v-model="loginForm.password"
                />
                <label for="name">請輸入您的密碼</label>
                <!-- 表单验证提示 -->
                <span class="varify"></span>
              </div>
              <button>登入</button>
            </div>
            <div class="forgetHelp">
              <div
                class="phoneHelp"
                @click="changeForgetPwdWay('forgetPwdByPhone')"
              >
                忘記密碼 (手機)
              </div>
              <div
                class="emailHelp"
                @click="changeForgetPwdWay('forgetPwdByEmail')"
              >
                忘記密碼 (電子郵件)
              </div>
            </div>
          </div>
        </div>
        <!-- 注册 -->
        <div class="register" v-else-if="active == 'register'">
          <div class="tips">
            透過 手機 / LINE 註冊， 即可直接解鎖推薦碼，享受優惠！
          </div>
          <div
            class="phoneRegister register_wrapper"
            v-if="registerWay == 'phone'"
          >
            <div class="form">
              <div class="phone">
                <select
                  v-model="registerByPhone.numberCode"
                  :class="{ borderColor: registerByPhone.numberCode != '' }"
                >
                  <option value="">請選擇</option>
                  <option value="+886">+886</option>
                  <option value="+852">+852</option>
                  <option value="+883">+883</option>
                </select>
                <div class="inputGroup">
                  <input
                    type="text"
                    required=""
                    autocomplete="off"
                    v-model="registerByPhone.number"
                  />
                  <label for="name">請輸入您的手機號碼</label>
                </div>
              </div>
              <!-- 手机号表单验证提示 -->
              <span class="varify"></span>
              <div class="code">
                <div class="inputGroup">
                  <span class="getCode">取得驗證碼</span>
                  <input
                    type="text"
                    required=""
                    autocomplete="off"
                    v-model="registerByPhone.VerificationCode"
                  />
                  <label for="name">簡訊驗證碼</label>
                  <!-- 验证码表单验证提示 -->
                  <span class="varify"></span>
                </div>
              </div>
              <div class="pwd">
                <div class="inputGroup">
                  <input
                    type="text"
                    required=""
                    autocomplete="off"
                    v-model="registerByPhone.password"
                  />
                  <label for="name">請輸入您的密碼</label>
                  <!-- 密码表单验证提示 -->
                  <span class="varify"></span>
                </div>
              </div>
              <button>註冊會員</button>
            </div>
          </div>
          <div class="emailRegister register_wrapper" v-else>
            <div class="form">
              <div class="emial">
                <div class="inputGroup">
                  <input
                    type="text"
                    required=""
                    autocomplete="off"
                    v-model="registerByEmail.email"
                  />
                  <label for="name">請輸入您的 Email</label>
                  <!-- 邮箱表单验证提示 -->
                  <span class="varify"></span>
                </div>
                <div class="inputGroup">
                  <input
                    type="text"
                    required=""
                    autocomplete="off"
                    v-model="registerByEmail.password"
                  />
                  <label for="name">請輸入您的密碼</label>
                  <!-- 密码表单验证提示 -->
                  <span class="varify"></span>
                </div>
                <button>註冊會員</button>
              </div>
            </div>
          </div>
          <!-- 切换注册方式 -->
          <div class="changeWay">
            <span
              v-if="registerWay == 'phone'"
              @click="changeRegisterWay('email')"
              >使用電子信箱註冊</span
            >
            <span v-else @click="changeRegisterWay('phone')"
              >使用手機號碼註冊</span
            >
          </div>
        </div>
        <div class="forget" v-else-if="active=='forgetPwd'&&forgetPwdWay == 'forgetPwdByPhone'">
          <div class="tips">透過以下電話接收驗證碼</div>
          <div class="form">
            <div class="phone">
              <select
                v-model="forgetPwdByPhone.numberCode"
                :class="{ borderColor: registerByPhone.numberCode != '' }"
              >
                <option value="">請選擇</option>
                <option value="+886">+886</option>
                <option value="+852">+852</option>
                <option value="+883">+883</option>
              </select>
              <div class="inputGroup">
                <input
                  type="text"
                  required=""
                  autocomplete="off"
                  v-model="forgetPwdByPhone.number"
                />
                <label for="name">請輸入您的手機號碼</label>
              </div>
            </div>
            <!-- 手机号表单验证提示 -->
            <span class="varify"></span>
            <div class="code">
              <div class="inputGroup">
                <span class="getCode">取得驗證碼</span>
                <input
                  type="text"
                  required=""
                  autocomplete="off"
                  v-model="forgetPwdByPhone.code"
                />
                <label for="name">簡訊驗證碼</label>
                <!-- 验证码表单验证提示 -->
                <span class="varify"></span>
              </div>
            </div>

            <button>重設密碼</button>
          </div>
        </div>

        <!-- 找回密码邮箱方式 -->
        <div class="forget container" v-else>
          <div
            class="tips"
            style="padding-left: 2em; padding-right: 2em; text-align: left"
          >
            忘記您的密嗎？請輸入您的使用者名稱或註冊的電子郵件。您將會在電子郵件信箱中收到重設密碼的連結。
          </div>
          <div class="form">
            <div class="inputGroup">
              <input
                type="text"
                required=""
                autocomplete="off"
                v-model="registerByEmail.email"
              />
              <label for="name">使用者名稱或電子郵件</label>
              <!-- 邮箱表单验证提示 -->
              <span class="varify"></span>
            </div>
            <button>重設密碼</button>
          </div>
        </div>
        <div class="changeWay" v-if="active=='forgetPwd'">
          <span
            v-if="forgetPwdWay == 'forgetPwdByPhone'"
            @click="changeForgetPwdWay('forgetPwdByEmail')"
            >使用 Email 重設</span
          >
          <span v-else @click="changeForgetPwdWay('forgetPwdByPhone')"
            >使用手機號碼重設</span
          >
        </div>
        <div class="toLogin" @click="changeCard('login')" v-if="active=='forgetPwd'">返回登錄頁</div>
      </div>
    </div>

    <!-- 更多登录方式 -->
    <div class="moreWay">
      <div>其它登入方式</div>
        <account-icon-vue/>
    </div>
  </div>
</template>

<script>
import AccountIconVue from '../common/AccountIcon.vue';
export default {
  name: "Login",
  components:{AccountIconVue},
  data() {
    return {
      // active:login,register,forgetPwd
      active: "login",
      // registerWay:phone,email
      registerWay: "phone",
      // forgetPwdWay:forgetPwdByPhone,forgetPwdByEmail
      forgetPwdWay: "phone",
      // 登录
      loginForm: {
        account: "",
        password: "",
      },
      // 电话注册账号
      registerByPhone: {
        numberCode: "",
        number: "",
        VerificationCode: "",
        password: "",
      },
      // 邮箱注册账号
      registerByEmail: {
        email: "",
        password: "",
      },
      // 电话找回密码
      forgetPwdByPhone: {
        numberCode: "",
        number: "",
        VerificationCode: "",
        password: "",
      },
      // 邮箱找回密码
      forgetPwdByEmail: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    // 切换登录或注册卡片
    changeCard(value) {
      this.active = value;
    },
    // 切换注册的方式（电话和邮箱）
    changeRegisterWay(value) {
      this.registerWay = value;
    },
    // 切换找回密码的方式
    changeForgetPwdWay(value) {
      this.active = "forgetPwd";
      this.forgetPwdWay = value;
    },
  },
};
</script>

<style lang="less" scoped>
#loginOrRegister {
  .container {
    width: 25em;
    .mobile({
      width: 100%
    });
  }
  .check {
    background-color: #fff6e9;
    height: 5em;
    .check_wrapper {
      .flex-mixin(row,center,center);
      > div {
        height: 5em;
        line-height: 5em;
        width: 7em;
        margin: 0 1em;
        border-bottom: 4px solid #e2e2e2;
        font-family: @font-family-variable;
        color: @primary-color;
        &:hover {
          cursor: pointer;
          color: black;
        }
      }
      .active {
        border-bottom: 4px solid #ff9e1b;
      }
    }
  }
  .card {
    // 表单验证样式
    .varify {
      font-size: 0.5em;
      background-color: #ccc;
    }
    // 切换方式样式
    .changeWay {
      margin: 1em auto;
      width: 21.5em;
      text-align: right;
      color: @primary-color;
      > span {
        font-size: 0.8em;
        &:hover {
          cursor: pointer;
          color: black;
        }
      }
    }
    // 提示样式
    .tips {
      padding: 3em 0 1em;
      font-size: 0.8em;
      color: #989898;
    }
    // 表单样式
    .form {
      .flex-mixin(column,center,center);
      .mobile({
        padding: 0 1em;
      });
      select{
        background-color: #fff;
      }
      button {
        width: 26em;
        border-radius: 10px;
        height: 2.8em;
        background-color: #ca7658;
        border: 0;
        color: white;
        &:hover {
          cursor: pointer;
          background-color: #a25e46;
        }
      }
      .inputGroup {
        margin: 0em 0 1em 0;
        width: 22em;
        position: relative;
        flex: 1;
      }

      .inputGroup input {
        font-size: 0.8em;
        height: 3em;
        padding: 0.5em;
        outline: none;
        border: 2px solid rgb(200, 200, 200);
        background-color: transparent;
        font-family: @font-family-bold;
        border-radius: 10px;
        width: 100%;
      }

      .inputGroup label {
        position: absolute;
        left: 0;
        margin: 1.5em;
        margin-left: 1.5em;
        pointer-events: none;
        transition: all 0.3s ease;
        font-size: 0.5em;
        color: rgb(100, 100, 100);
      }

      .inputGroup :is(input:focus, input:valid) ~ label {
        transform: translateY(-50%) scale(0.9);
        margin: 0em;
        margin-left: 1.3em;
        padding: 0.4em;
        background-color: #e8e8e8;
        background-color: #fff;
      }

      .inputGroup :is(input:focus, input:valid) {
        border-color: rgb(150, 150, 200);
        border-color: #ff9e1b;
      }
    }
    // 登录
    .login {
      .forgetHelp {
        margin: 1em auto;
        width: 26em;
        font-size: 0.8em;
        color: #989898;
        .flex-mixin(row,space-between,center);
        .phoneHelp,
        .emailHelp {
          &:hover {
            cursor: pointer;
            color: @primary-color;
          }
        }
      }
    }

    // 返回登录
    .toLogin {
      font-size: 0.8em;
      color: #989898;
      &:hover {
        color: @primary-color;
        cursor: pointer;
      }
    }
    // 注册
    .register,
    .forget {
      .phone {
        .flex-mixin(row,start,center);
        .borderColor {
          border-color: #ff9e1b;
        }
        select {
          width: 6em;
          margin: 0 1em 1em 0;
          height: 2.5em;
          border-radius: 10px;
          font-family: @font-family-bold;
          border: 2px solid rgb(200, 200, 200);
        }
        .inputGroup {
          margin: 0em 0 1em 0;
          width: 16em;
          position: relative;
          border: 2px;
        }
      }
      .code {
        .getCode {
          position: absolute;
          right: 1em;
          top: 0.7em;
          font-size: 0.8em;
          color: #cd7658;
          &:hover {
            cursor: pointer;
            color: @primary-color;
          }
        }
      }
    }
  }
  .moreWay{
    margin: 3em 0;
    height: 10em;
    background-color: #EEEEEE;
    font-size: .8em;
    color: #777777;
    padding: 1em 0;
    
  }
}
</style>